export default __webpack_public_path__ + "static/media/area-30.1ed12719.jpg";